<template>
  <div>
    <b-row>
      <b-col>
        <b-jumbotron
          header-level="6"
          bg-variant="white"
          class="p-4 rounded-0">
          <template slot="header">
            {{ $t('message.dashboard.title', { userName: userName }) }}
          </template>
        </b-jumbotron>
      </b-col>
    </b-row>

    <dashboard-content-contact-person
      v-if="isContactPerson && !isPolicyHolder"
      class="mt-4">
    </dashboard-content-contact-person>

    <dashboard-content
      v-if="isPolicyHolder"
      class="mt-4">
    </dashboard-content>

    <b-row class="mt-4">
      <b-col>
        <router-link to="/faq" class="infobox-link-faq">
          <b-card :title="$t('message.dashboard.faq.title')" class="infoboxFaq rounded-0 h-100">
            <span v-html="$t('message.dashboard.faq.text')"></span>
          </b-card>
        </router-link>
      </b-col>
      <b-col>
        <b-card :title="$t('message.dashboard.info.title')" class="rounded-0 h-100">
          <span v-html="$t('message.dashboard.info.text')"></span>
        </b-card>
      </b-col>
    </b-row>

    <b-row class="mt-4" v-if="isPolicyHolder">
      <b-col>
        <b-card :title="$t('message.dashboard.powerOfAttorney.title')" class="rounded-0 h-100">
          <span v-html="$t('message.dashboard.powerOfAttorney.explanation')"></span>
          <b-row>
            <b-col>
              <ul class="list-unstyled">
                <li><span class="ti-printer mr-2"></span>{{ $t('message.dashboard.powerOfAttorney.step1') }}</li>
                <li><span class="ti-marker-alt mr-2"></span>{{ $t('message.dashboard.powerOfAttorney.step2') }}</li>
                <li><span class="ti-email mr-2"></span>{{ $t('message.dashboard.powerOfAttorney.step3') }}</li>
                <li class="offset-2"><span v-html="$t('message.dashboard.powerOfAttorney.address')"></span>
                </li>
              </ul>
            </b-col>
            <b-col class="text-right mt-auto">
              <b-btn href="/static/documents/Vollmacht_meine-vertraege.pdf" target="_blank">
                <span class="ti-download mr-2"></span>{{ $t('message.dashboard.powerOfAttorney.download') }}
              </b-btn>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
  import DashboardContent from '@/components/dashboard/DashboardContent'
  import DashboardContentContactPerson from '@/components/dashboard/DashboardContentContactPerson'
  import Infobox from '@/components/common/Infobox'

  export default {
    components: {
      DashboardContent,
      DashboardContentContactPerson,
      Infobox
    },
    computed: {
      isContactPerson () {
        const currentUser = this.$store.getters.currentUser
        if (Object.keys(currentUser).length > 0) {
          const rolesContactPerson = currentUser.roles.filter(role => role.roleOfUser === 'CONTACT_PERSON')
          if (rolesContactPerson.length > 0) {
            return true
          }
        }
        return false
      },
      isPolicyHolder () {
        const currentUser = this.$store.getters.currentUser
        if (Object.keys(currentUser).length > 0) {
          const rolesPolicyHolder = currentUser.roles.filter(role => role.roleOfUser === 'POLICY_HOLDER')
          if (rolesPolicyHolder.length > 0) {
            return true
          }
        }
        return false
      },
      userName () {
        const user = this.$store.getters.currentUser
        return this.$t('enums.salutations.' + user.salutation) + ' ' + user.firstName + ' ' + user.lastName
      }
    }
  }
</script>
<style scoped>
  .infobox-link-faq {
    color: #455a64;
    background-color: white;
  }

  .infobox-link-faq:hover {
    color: #455a64;
    text-decoration: none;
  }

  .infoboxFaq:hover{
    background-color: lightgray;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/Dashboard.vue